<div
  class="c-dropdown wrapper"
  data-automation-e2e-selector="orderMonitorFilter"
  [title]="tooltipMessage"
  [ngClass]="{ highlight: highlightAll }"
  (onOutsideClick)="hideDropdown()"
>
  <button
    class="c-link toggle"
    #manualDropdown
    (click)="toggleDropdown()"
    [ngClass]="{ 'sole-managed': isSoleManagedDeal }"
    [cupcakeDropdownTrigger]="{ trigger: 'manual' }"
  >
    <span
      data-automation-e2e-selector="filterTitle"
      [textContent]="showingLabel"
    >
    </span>
    <span
      class="selected-filter"
      data-automation-e2e-selector="filterState"
      [textContent]="selectedFilters"
      [ngClass]="{ 'all-items': isAll }"
    >
    </span>
    <i class="fa fa-angle-down" aria-hidden="true"></i>
  </button>
  <ul class="c-dropdown-list c-dropdown-list-below c-dropdown-list-right">
    <li>
      <muni-gameday-all-radio-selector
        data-automation-e2e-selector="leadSyndicateRadioSelector"
        #radioSelector
        [itemGroups]="itemGroups"
        [values]="values"
        (selected)="onSelect($event)"
      >
      </muni-gameday-all-radio-selector>
    </li>
  </ul>
</div>
